import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ToastContext, useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import generalServices from '@/general/services/services'

import Security from './Security/Security'

const SecurityConfiguration = () => {
  const { info } = useContext(AppContext)
  const { setToastInfo } = useContext(ToastContext)
  const { t } = useTranslation()

  const { loading: changingPassword, fetchData: changePassword } = useFetch(generalServices.changePassword, {
    doInitialRequest: false,
  })
  const [changePasswordErrors, setChangePasswordErrors] = useState(null)
  const onChangePassword = (oldPassword, newPassword, cb) => {
    const payload = {
      old_password: oldPassword,
      new_password: newPassword,
    }

    if (!info.userInfo?.has_usable_password) delete payload.old_password

    changePassword(
      payload,
      () => {
        setChangePasswordErrors(null)
        setToastInfo({ show: true, message: t('Contraseña cambiada correctamente'), type: 'success' })
        cb()
      },
      err => {
        setChangePasswordErrors(err.response.data)
      }
    )
  }

  return (
    <Security
      changingPassword={changingPassword}
      errors={changePasswordErrors}
      onChangePassword={onChangePassword}
      hasUsablePassword={info.userInfo?.has_usable_password}
    />
  )
}

export default SecurityConfiguration
